var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-heading',{attrs:{"show":true,"pageTitle":"COMPLAT-CALENDAR-HEADLINE"}}),_c('calendar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }